const state = {
  episode: {},
  episodes: [],
  episodeCount: '-',
  episodeCreationKeys: [],
  lastEpisode: {},
  topEpisode: {}
}

export default state
